angular.module('app.ipAddressService', [])
  .value('ipAddress', {address: null})
  .factory('app.ipAddressService', [
    '$http', 'ipAddress', '$q',
    function ($http, ipAddress, $q) {
      let service = {
        activeBreaker: null,
        getFromMaxMind: () => {
          let deferred = $q.defer();

          geoip2.insights(
            (response) => {
              if (response.traits && response.traits.ip_address) {
                ipAddress.address = response.traits.ip_address;
                deferred.resolve(response);
              } else {
                deferred.reject(response);
              }
            },
            (response) => {
              deferred.reject(response);
            }
          );

          return deferred.promise;
        },
        getFromUrl: (url, callback) => {
          return $http.get(url)
            .then(function (response) {
              if (typeof callback === 'function') {
                callback(response);
              } else {
                if (response.data === null || typeof response.data !== 'undefined') {
                  ipAddress.address = null;
                }

                ipAddress.address = response.data.ip;
              }

              return response;
            });
        },
        retrieve: function () {
          let deferred = $q.defer();
          let internalPromise;

          deferred.resolve({ip_address: null});
          return deferred.promise;

          if (service.activeBreaker) {
            let breaker = $q.defer();
            breaker.resolve();
            internalPromise = breaker.promise;
          } else {
            internalPromise = $http.get(window.location.api('service_breakers/groups/ip_address'));
          }

          internalPromise.then(
            response => {
              let data = response.data;
              if (Array.isArray(data) && data.length) {
                let breaker = data[0];
                if (parseInt(breaker.status) === 0) {
                  service.activeBreaker = breaker;
                }
              } else {
                service.activeBreaker = null;
              }

              if (service.activeBreaker) {
                service.getFromUrl(service.activeBreaker.url)
                  .then(
                    response => {
                      let data = response.data;

                      switch (service.activeBreaker.name) {
                        case 'Ipify':
                        case 'JsonIp':
                          ipAddress.address = data.ip;
                          deferred.resolve({ip: data.ip});
                          break;
                        default:
                          deferred.reject();
                          break;
                      }
                    },
                    () => {
                      deferred.reject();
                    }
                  );
              } else {
                deferred.reject();
              }
            }
          );

          return deferred.promise;
        }
      };

      return service;
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/fhApp/ipAddressService.js